import {ExtendableError} from 'ts-error';

export type ErrorPayload = StatusErrorPayload | unknown;

export function isStatusErrorPayload(payload: ErrorPayload): payload is StatusErrorPayload {
  return (
    (payload as StatusErrorPayload)?.statusCode !== undefined &&
    (payload as StatusErrorPayload)?.isUserFacing !== undefined
  );
}

export interface StatusErrorPayload {
  isUserFacing: boolean;
  message: string;
  stack: string;
  statusCode: number;
}

export class HttpError extends ExtendableError {
  constructor(
    public name: string,
    public message: string,
    public status?: number,
    public stack?: string,
    public payload?: ErrorPayload,
  ) {
    super();
  }

  isAuthError(): boolean {
    if (!this.status) {
      return false;
    }

    return [401, 403].includes(this.status);
  }

  get isUserFacing(): boolean {
    if (isStatusErrorPayload(this.payload)) {
      return this.payload.isUserFacing;
    }

    return false;
  }
}
